import axios, { AxiosInstance } from "axios";
import { getAccessToken } from "@/providers/supabase-auth-provider";

/**
 * Axios instance for custom API endpoints (non-Supabase).
 * Includes auth interceptor but NOT the Supabase apikey header.
 */
const authApi: AxiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

// Add auth interceptor to include Bearer token for authenticated endpoints
authApi.interceptors.request.use(async (config) => {
  // Skip auth for public endpoints (signin, signup, etc.)
  const publicEndpoints = ["/auth/signin", "/auth/signup", "/auth/signout"];
  const isPublicEndpoint = publicEndpoints.some((endpoint) =>
    config.url?.includes(endpoint),
  );

  if (!isPublicEndpoint) {
    const accessToken = await getAccessToken();
    if (accessToken) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  // Let the browser set multipart boundaries for FormData payloads.
  // For non-FormData requests, default to JSON when caller did not specify one.
  if (config.data instanceof FormData) {
    if (config.headers) {
      delete config.headers["Content-Type"];
    }
  } else {
    config.headers = config.headers ?? {};
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
  }

  return config;
});

export default authApi;
